/**
 * Auth barrel — re-exports from split modules + initAuth() orchestrator.
 * Zero breaking changes for existing imports.
 */

// Re-export from core (pure logic — zero DOM)
export {
  getToken, setToken, clearToken, isNoAuth, requireAuth, authFetch, authUrl,
  getUserEmail, escHtml, isTokenExpired,
  dispatchAuthLogin, dispatchAuthLogout,
} from "./auth/core.js";

// Re-export from account (UI — all DOM)
export { loginOverlay, logout } from "../DOM/components/account.js";

// Internal imports for initAuth orchestrator
import { loadConfig } from "./config.js";
import { initAccountUI } from "../DOM/components/account.js";
import { isNoAuth, requireAuth } from "./auth/core.js";

export async function initAuth(): Promise<void> {
  await loadConfig();
  initAccountUI();

  const overlay = document.getElementById("loginOverlay");
  if (!overlay) return;

  if (isNoAuth()) {
    // Auth disabled — keep overlay hidden
    overlay.classList.add("hidden");
  } else {
    // Auth enabled — check token validity; show overlay if unauthenticated
    requireAuth(); // dispatches auth:unauthenticated if token missing/expired
  }
}
